<template>
  <div class="menu-side bg--blue-dark tx--bege">
    <div class="hold-menu">
      <div class="head--pad">
        <router-link to="/dashboard">
          <div class="logo">
            <LogoSvg />
          </div>
        </router-link>
        <div class="mm-user">
          <div class="user_row">
            שלום {{ activeUser.name }}.
            <a href="javascript:void(0)" @click="logout()">התנתקות</a>
          </div>
          <router-link to="/messages" class="mm-my-msg">
            <div class="relative">
              <span
                v-show="
                  activeUser &&
                    activeUser.doctor_messages &&
                    activeUser.doctor_messages.length
                "
                class="pathology-dot"
              ></span>
              <img src="/assets/img/svg/sm-mail.svg" />
            </div>
            <div>יש לך <span class="underline">הודעות</span></div>
          </router-link>
        </div>
      </div>
      <nav class="menu">
        <template v-for="item in menuList">
          <div
            :key="item.path"
            class="menu_item pointer"
            :class="{
              active: $route.path == item.path || $route.path == item.path + '/'
            }"
            v-if="isMenuItemVisible(item)"
          >
            <a
              v-if="item.target"
              :href="item.path"
              :target="item.target"
              class="menu_item_top ease"
            >
              {{ item.title }}
            </a>
            <a
              v-else
              class="menu_item_top ease"
              :href="item.path"
              @click.prevent="onRoute(item.path)"
            >
              {{ item.title }}
              <span v-if="matchesDocsType(item.path)">
                <Bell class="pathology-bell" />
                <div
                  v-if="hasUnwatchedDocs(item.type)"
                  class="pathology-dot"
                ></div>
              </span>
            </a>
          </div>
        </template>
        <div class="menu_item pointer">
          <a class="menu_item_top ease" @click="openUploadPolicies"
            >טעינת קובץ ביטוח</a
          >
        </div>
      </nav>
      <div class="mm-bottom">
        <SearchFilter :isMenu="true" />
        <a href="tel:0747049400" class="phone-text flex flex--start">
          <img src="/assets/img/svg/ic-phone-white.svg" alt="" />
          <span>תמיכה</span>
          <a>077-6450466</a>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import LogoSvg from "../../assets/img/svg/logo.svg";
import UploadPolicies from "../Popups/UploadPolicies.vue";
import Bell from "../../assets/img/svg/bell.svg";
import SearchFilter from "@/components/Shared/SearchFilter.vue";
import { mapActions, mapGetters } from "vuex";
import { menuList } from "../../utilities/globals.js";
import { IVF_TREATMENT_LIST_ENABLED } from "../../utilities/feature-flags.js";

export default {
  name: "MenuDesktop",
  components: { LogoSvg, Bell, SearchFilter },
  computed: {
    ...mapGetters([
      "activeUser",
      "activeDoctor",
      "doctors",
      "hasUnwatchedDocs",
      "docsTypes",
      "showIVF"
    ])
  },
  data() {
    return {
      menuList
    };
  },
  methods: {
    ...mapActions(["LOGOUT"]),
    logout() {
      sessionStorage.removeItem("initial-route");
      this.LOGOUT().then(() => {
        this.$API.logout().then(() => this.$router.push("/"));
      });
    },
    onRoute(path) {
      if (this.$route.path == path || this.$route.path == path + "/") {
        if (path.includes("cellosign") || path.includes("cellosign-iframe")) {
          // Reload the page
          this.$router.go(0);
        }
        return;
      }
      this.$router.push(path);
    },
    openUploadPolicies() {
      this.$modal.show(UploadPolicies);
    },
    matchesDocsType(path) {
      return Object.keys(this.docsTypes).some(key => path.includes(key));
    },
    isMenuItemVisible(item) {
      if (item.path === "/table/ivf" && !IVF_TREATMENT_LIST_ENABLED) {
        return false;
      }
      if (item.requiresIVF && !this.showIVF) {
        return false;
      }
      return true;
    }
  }
};
</script>
